export const isAllPermissionInclude = (predicate, authPolicyCodes) => {
    if (Array.isArray(predicate)) {
        return !predicate.every((item) => authPolicyCodes.indexOf(item) !== -1);
    } else {
        return !authPolicyCodes.some((item) => item === predicate);
    }
};

export const isAnyPermissionInclude = (predicate, authPolicyCodes) => {
    if (Array.isArray(predicate)) {
        return !predicate.some((item) => authPolicyCodes.indexOf(item) !== -1);
    } else {
        return !authPolicyCodes.some((item) => item === predicate);
    }
};
